import React from 'react'

type CardContentProps = {
  children: React.ReactNode
  className?: string
}

const CardContent: React.FC<CardContentProps> = ({ children, className = '' }) => (
  <div className={`flex flex-col justify-center w-[338px] max-w-[338px] ${className}`}>
    {children}
  </div>
)

export default CardContent
